"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "NotificationsController", {
    enumerable: true,
    get: function() {
        return NotificationsController;
    }
});
const _common = require("@nestjs/common");
const _nanoid = require("nanoid");
const _notificationsservice = require("~/services/notifications/notifications.service");
const _globalguard = require("~/guards/global/global.guard");
const _extractProps = require("~/helpers/extractProps");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
const _config = require("~/interface/config");
const _pubsubredis = require("~/redis/pubsub-redis");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
const nanoidv2 = (0, _nanoid.customAlphabet)('1234567890abcdefghijklmnopqrstuvwxyz', 14);
const POLL_INTERVAL = 30000;
let NotificationsController = class NotificationsController {
    onModuleDestroy() {
        for (const [_, res] of this.notificationsService.connections){
            res.forEach((r)=>{
                if (!r.headersSent) {
                    r.send({
                        status: 'refresh'
                    });
                }
            });
        }
    }
    async notificationPoll(req, res) {
        res.setHeader('Cache-Control', 'no-cache, must-revalidate');
        res.resId = nanoidv2();
        this.notificationsService.addConnection(req.user.id, res);
        let unsubscribeCallback = null;
        if (_pubsubredis.PubSubRedis.available) {
            unsubscribeCallback = await _pubsubredis.PubSubRedis.subscribe(`notification:${req.user.id}`, async (data)=>{
                this.notificationsService.sendToConnections(req.user.id, data);
            });
        }
        res.on('close', async ()=>{
            await this.notificationsService.removeConnection(req.user.id, res, unsubscribeCallback);
        });
        setTimeout(()=>{
            if (!res.headersSent) {
                res.send({
                    status: 'refresh'
                });
            }
        }, POLL_INTERVAL).unref();
    }
    async notificationList(req) {
        return this.notificationsService.notificationList(_extends({
            user: req.user,
            is_deleted: false
        }, req.query, {
            is_read: req.query.is_read === 'true'
        }));
    }
    async notificationUpdate(notificationId, body, req) {
        return this.notificationsService.notificationUpdate({
            notificationId,
            body: (0, _extractProps.extractProps)(body, [
                'is_read'
            ]),
            user: req.user
        });
    }
    async notificationDelete(notificationId, req) {
        return this.notificationsService.notificationDelete({
            notificationId,
            user: req.user
        });
    }
    async markAllRead(req) {
        return this.notificationsService.markAllRead({
            user: req.user
        });
    }
    constructor(notificationsService){
        this.notificationsService = notificationsService;
    }
};
_ts_decorate([
    (0, _common.Get)('/api/v1/notifications/poll'),
    (0, _extractidsmiddleware.Acl)('notification', {
        scope: 'org'
    }),
    _ts_param(0, (0, _common.Req)()),
    _ts_param(1, (0, _common.Res)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        Object
    ]),
    _ts_metadata("design:returntype", Promise)
], NotificationsController.prototype, "notificationPoll", null);
_ts_decorate([
    (0, _common.Get)('/api/v1/notifications'),
    (0, _extractidsmiddleware.Acl)('notification', {
        scope: 'org'
    }),
    _ts_param(0, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], NotificationsController.prototype, "notificationList", null);
_ts_decorate([
    (0, _common.Patch)('/api/v1/notifications/:notificationId'),
    (0, _extractidsmiddleware.Acl)('notification', {
        scope: 'org'
    }),
    _ts_param(0, (0, _common.Param)('notificationId')),
    _ts_param(1, (0, _common.Body)()),
    _ts_param(2, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        void 0,
        void 0,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], NotificationsController.prototype, "notificationUpdate", null);
_ts_decorate([
    (0, _common.Delete)('/api/v1/notifications/:notificationId'),
    (0, _extractidsmiddleware.Acl)('notification', {
        scope: 'org'
    }),
    _ts_param(0, (0, _common.Param)('notificationId')),
    _ts_param(1, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        void 0,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], NotificationsController.prototype, "notificationDelete", null);
_ts_decorate([
    (0, _common.Post)('/api/v1/notifications/mark-all-read'),
    (0, _extractidsmiddleware.Acl)('notification', {
        scope: 'org'
    }),
    (0, _common.HttpCode)(200),
    _ts_param(0, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], NotificationsController.prototype, "markAllRead", null);
NotificationsController = _ts_decorate([
    (0, _common.Controller)(),
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _notificationsservice.NotificationsService === "undefined" ? Object : _notificationsservice.NotificationsService
    ])
], NotificationsController);
